import startCaseStringUtil from '../start-case'

export default function capitalizeEachWordStringUtil (str) {
  return startCaseStringUtil(
    str.toLowerCase().replace(/_/g, ' ')
  )
}
